module.exports = __webpack_public_path__ + "img/CliSet2.c2b66e51.jpg";